/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import ReactFromPrismic from '../ReactFromPrismic';

import mapNavProps from '../../utils/map-nav-props';

import Nav from './Nav';
import NavList from './NavList';
import NavItem from './NavItem';
import { useCountry } from '../../hooks';

const Navigation = ({ navId, links }) => {
  const country = useCountry();
  return (
    <section className="navigation">
      <ReactFromPrismic
        entry={{
          ...links,
          navRootId: navId,
        }}
        mapAdditionalProps={(prop, type) => mapNavProps(prop, country, type)}
        mapping={{
          nav: Nav,
          nav_list: NavList,
          nav_item: NavItem,
        }}
      />
    </section>
  );
};

Navigation.propTypes = {
  navId: PropTypes.string.isRequired,
  links: PropTypes.object.isRequired,
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Navigation/Navigation.js